import { Box, Divider, Flex } from "@chakra-ui/react"
import { FramerBox } from "@components/animations/FramerBox"
import { ScanOrderPayData } from "@data/animations"
import { AnimatePresence } from "framer-motion"
import Image from "next/image"
import { useTranslations } from "next-intl"

const ScanOrderPay = () => {
  const t = useTranslations("home")

  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      w={"full"}
      mt={100}
      position={"relative"}
    >
      {ScanOrderPayData.map((item, index) => (
        <AnimatePresence key={index}>
          <FramerBox
            key={index}
            initial={{ opacity: 0, x: 0, y: 0, scale: 0 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 0,
            }}
            exit={{ opacity: 0, x: 0, y: 0, scale: 0 }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            transition={{
              duration: 0.2,
              ease: "easeInOut",
              delay: (index + 1) * 0.1,
            }}
          >
            <Flex
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
              px={{ base: 4, md: 10 }}
              position={"relative"}
            >
              <Image
                src={item.image}
                loader={({ src }) => src}
                alt={t(item.title)}
                style={{ zIndex: index + 1 }}
              />
              {index === 1 && (
                <Divider
                  position={"absolute"}
                  borderColor={"brand.secondary"}
                  borderWidth={{ base: 1, md: 2 }}
                  borderStyle={"solid"}
                  transform={"translateY(-26px)"}
                />
              )}
              <Box
                mt={4}
                color={"brand.secondary"}
                fontWeight={"bold"}
                fontSize={"2xl"}
              >
                {t(item.title)}
                {"."}
              </Box>
            </Flex>
          </FramerBox>
        </AnimatePresence>
      ))}
      <Divider
        position={"absolute"}
        borderColor={"brand.secondary"}
        borderWidth={{ base: 1, md: 2 }}
        borderStyle={"dashed"}
        transform={"translateY(-26px)"}
      />
    </Flex>
  )
}

export default ScanOrderPay
